/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_spec_card__roadsheet__title = /** @type {(inputs: {}) => string} */ () => {
	return `Roadmap`
};

const en_route_spec_card__roadsheet__title = /** @type {(inputs: {}) => string} */ () => {
	return `Roadmap`
};

const es_route_spec_card__roadsheet__title = /** @type {(inputs: {}) => string} */ () => {
	return `Mapa de carreteras`
};

const fr_route_spec_card__roadsheet__title = /** @type {(inputs: {}) => string} */ () => {
	return `Feuille de route`
};

const it_route_spec_card__roadsheet__title = /** @type {(inputs: {}) => string} */ () => {
	return `Mappa stradale`
};

const nl_route_spec_card__roadsheet__title = /** @type {(inputs: {}) => string} */ () => {
	return `Wegenkaart`
};

const pt_route_spec_card__roadsheet__title = /** @type {(inputs: {}) => string} */ () => {
	return `Mapa rodoviário`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_spec_card__roadsheet__title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_spec_card__roadsheet__title", locale)
	if (locale === "de") return de_route_spec_card__roadsheet__title(inputs)
	if (locale === "en") return en_route_spec_card__roadsheet__title(inputs)
	if (locale === "es") return es_route_spec_card__roadsheet__title(inputs)
	if (locale === "fr") return fr_route_spec_card__roadsheet__title(inputs)
	if (locale === "it") return it_route_spec_card__roadsheet__title(inputs)
	if (locale === "nl") return nl_route_spec_card__roadsheet__title(inputs)
	return pt_route_spec_card__roadsheet__title(inputs)
};